import { Container } from 'react-bootstrap';
import './addRow.css';

function AddRow() {
  return (
    <section className="addRow">
      <Container>
        <div className="add">
          <h3>Ad Space</h3>
        </div>
      </Container>
    </section>
  );
}

export default AddRow;
